module.exports = __webpack_public_path__ + "static/media/profile-user.f9921060.webp";